import apiClient from '../utils/apiClient';

// #120207 — Màn duyệt thay đổi + bộ cài tự động đặt hàng (đều là màn NỘI BỘ, có đăng nhập).
// #182152 — Phần gọi API cổng NCC (public, không đăng nhập) đã chuyển sang kho MENU
// (`on-coffee-menu/lib/api/supplier-order-portal.ts`); ở đây không còn axios trần nữa.

export const supplierOrderChangeAPI = {
  list: async (params = {}) =>
    apiClient.get({ url: '/supplier-order-changes', params }),

  pendingCount: async (branchId) =>
    apiClient.get({ url: '/supplier-order-changes/pending-count', params: { branch_id: branchId } }),

  getDetail: async (id) =>
    apiClient.get({ url: `/supplier-order-changes/${id}` }),

  approve: async (id) =>
    apiClient.post({ url: `/supplier-order-changes/${id}/approve`, data: {} }),

  reject: async (id, reason) =>
    apiClient.post({ url: `/supplier-order-changes/${id}/reject`, data: { reason } }),
};

export const supplierAutoOrderAPI = {
  list: async (params = {}) =>
    apiClient.get({ url: '/supplier-auto-orders', params }),

  getDetail: async (id) =>
    apiClient.get({ url: `/supplier-auto-orders/${id}` }),

  preview: async (id) =>
    apiClient.get({ url: `/supplier-auto-orders/${id}/preview` }),

  create: async (data) =>
    apiClient.post({ url: '/supplier-auto-orders', data }),

  update: async (id, data) =>
    apiClient.put({ url: `/supplier-auto-orders/${id}`, data }),

  runNow: async (id, branchIds) =>
    apiClient.post({
      url: `/supplier-auto-orders/${id}/run-now`,
      data: branchIds?.length ? { branch_ids: branchIds } : {},
    }),

  remove: async (id) =>
    apiClient.delete({ url: `/supplier-auto-orders/${id}` }),
};
